import { BaseDashboardViewState, INITIAL_DASHBOARD_VIEW_STATE } from '../documents.state';

export interface ArchivedDocumentsState {
  dashboardView: BaseDashboardViewState;
}

export const INITIAL_ARCHIVED_DOCUMENTS_STATE: ArchivedDocumentsState = {
  dashboardView: {
    ...INITIAL_DASHBOARD_VIEW_STATE,
    searchParams: { ...INITIAL_DASHBOARD_VIEW_STATE.searchParams, defaultDateRange: true },
  },
};
